import makeApi from "../../libs/axios/api";
import { GuestOrderPayload } from "../../types/guestOrder";
const apiPromise = makeApi();

const GUEST_PATH = "/guest-orders";

const submitGuestOrder = async (data: GuestOrderPayload): Promise<any> => {
  const api = await apiPromise;
  const formData = new FormData();

  Object.entries(data).forEach(([key, value]) => {
    if (typeof value === "object" && key !== "OrderAttachments") {
      Object.entries(value).forEach(([subKey, subValue]) => {
        formData.append(`${key}.${subKey}`, String(subValue));
      });
    } else if (key === "OrderAttachments" && Array.isArray(value)) {
      value.forEach((attachment, index) => {
        if (attachment) {
          Object.entries(attachment).forEach(
            ([attachmentKey, attachmentValue]) => {
              formData.append(
                `${key}[${index}].${attachmentKey}`,
                attachmentValue instanceof File
                  ? attachmentValue
                  : String(attachmentValue)
              );
            }
          );
        }
      });
    } else {
      formData.append(key, String(value));
    }
  });

  return api.post(GUEST_PATH, formData).then((response) => {
    return response.data;
  });
};


export {
  submitGuestOrder
};
